import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PlatformApiModule } from '@data/_generated-api/platform-api/platform-api.module';
import { TypedClassProvider } from '@shared/ioc/typed-class-provider';

import { registerSchemas } from '@common/mapper';

import { CredentialLoginComponent } from './components/login/credential-login/credential-login.component';
import { LoginFactoryComponent } from './components/login/login-factory/login-factory.component';
import { FormsModule } from '@angular/forms';

import { MatIconModule } from '@angular/material/icon';
import { AuthenticatedUserIndicatorComponent } from './components/authenticated-user-indicator/authenticated-user-indicator.component';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import {
  AUTHENTICATION_REFRESHER,
  AUTHENTICATION_SERVICE
} from '@/app/platform/platform-core/user/services/types';
import {
  AUTHENTICATED_USER_ACTIONS,
  USER_QUERIES,
  USER_VALIDATION_ACTIONS
} from '@/app/platform/platform-core/user/store/types';
import { UserStoreQueries } from '@/app/platform/platform-core/user/store/user-store.queries';
import { userMapperSchemas } from '@/app/platform/platform-core/user/mapper';
import { UserValidationStoreActions } from '@/app/platform/platform-core/user/actions/user-validation-store.actions';
import { AuthenticatedUserStoreActions } from '@/app/platform/platform-core/user/actions/authenticated-user-store.actions';
import { AUTHENTICATION_OBSERVABLE_FACTORY } from '@/app/platform/platform-core/user/factories/types';
import { JwtAuthenticationObservableFactory } from '@/app/platform/platform-core/user/factories/jwt-authentication-observable.factory';
import { UserInitializer } from '@/app/platform/platform-core/user/initializers/user-initializer';
import { ACTIVE_APP_QUERIES } from '@/app/platform/platform-core/user/queries/types';
import { RouterActiveAppQueries } from '@/app/platform/platform-core/user/queries/router-active-app.queries';
import { USER_ACTIVATOR } from '@/app/platform/platform-core/user/activators/types';
import { StoreUserActivator } from '@/app/platform/platform-core/user/activators/store-user-activator';
// MDB Angular Pro
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtTokenHttpInterceptor } from '@/app/platform/platform-core/user/http-interceptors/jwt-token-http-interceptor';
import { SharedModule } from '@shared/shared.module';
import { PlatformInstanceListener } from '@/app/platform/platform-core/user/listeners/platform-instance-listener';
import { MultiListenerProvider } from '@/types/listener.types';
import { NgSelectModule } from '@ng-select/ng-select';
import { ErrorMappersModule } from '@data/_generated-api/error-mappers/error-mappers.module';
import { MultiLanguageModule } from '@/app/multi-language.module';
import { environment } from '@/environments/environment';
import { JwtAuthenticationRefresher } from '@/app/platform/platform-core/user/services/jwt-authentication-refresher';
import { UserSettingsContainerComponent } from './containers/user-settings-container/user-settings-container.component';
import { AuthenticationApiService } from '@/app/platform/platform-core/user/services/authentication-api.service';

@NgModule({
  declarations: [
    CredentialLoginComponent,
    LoginFactoryComponent,
    AuthenticatedUserIndicatorComponent,
    UserSettingsContainerComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    PlatformApiModule.forRoot({
      rootUrl: environment.apiPaths.egituraPlatformApi
    }),
    FormsModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatDividerModule,
    SharedModule,
    NgSelectModule,
    ErrorMappersModule,
    MultiLanguageModule
  ],
  exports: [
    CredentialLoginComponent,
    LoginFactoryComponent,
    AuthenticatedUserIndicatorComponent
  ],
  providers: [
    new TypedClassProvider(AUTHENTICATION_SERVICE, AuthenticationApiService),
    new TypedClassProvider(USER_QUERIES, UserStoreQueries),
    new TypedClassProvider(USER_VALIDATION_ACTIONS, UserValidationStoreActions),
    new TypedClassProvider(AUTHENTICATED_USER_ACTIONS, AuthenticatedUserStoreActions),
    new TypedClassProvider(AUTHENTICATION_OBSERVABLE_FACTORY, JwtAuthenticationObservableFactory),
    UserInitializer,
    new TypedClassProvider(ACTIVE_APP_QUERIES, RouterActiveAppQueries),
    new TypedClassProvider(USER_ACTIVATOR, StoreUserActivator),
    {
      multi: true,
      provide: HTTP_INTERCEPTORS,
      useClass: JwtTokenHttpInterceptor
    },
    PlatformInstanceListener,
    new MultiListenerProvider(PlatformInstanceListener),
    new TypedClassProvider(AUTHENTICATION_REFRESHER, JwtAuthenticationRefresher)
  ]
})
export class UserModule {
  constructor() {
    registerSchemas(userMapperSchemas);
  }
}
